import { render, staticRenderFns } from "./TC.vue?vue&type=template&id=2e210e21&scoped=true&"
import script from "./TC.vue?vue&type=script&lang=js&"
export * from "./TC.vue?vue&type=script&lang=js&"
import style0 from "./TC.vue?vue&type=style&index=0&id=2e210e21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e210e21",
  null
  
)

export default component.exports